import Feedback from './Feedback.vue';

const feedbackRoutes = [ 
  {
    path: '/feedback',
    name: 'Feedback',
    component: Feedback,
    meta: { requiresAuth: true },
  },
];

export default feedbackRoutes;
